<div class="row plp-desktop-item" *ngIf="!isMobileView; else plpMbileTmpl">
  <a [attr.aria-label]="
        !product.images?.hasOwnProperty('PRIMARY')
          ? ('productDetails.noProductImage'
            | cxTranslate: { product: product.name })
          : undefined
      " [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" (click)="selectItem(product)"
    [queryParams]="{gaListName: gaListName, entry_source: gaEntrySource}" class="cx-product-image-container">
    <cx-media class="cx-product-image"
      *ngIf="(product.servicePart && product.images?.PRIMARY) || !product.servicePart; else spGearThumb"
      [container]="product.images?.PRIMARY" format="product" [alt]="product.name || product.summary"></cx-media>
    <ng-template #spGearThumb>
      <img src="../../../../../../assets/icons/sp_gear_thumb.svg" alt="gear" class="sp-gear-thumb">
    </ng-template>
  </a>
  <div class="product-name-container">
    <div class="product-name-wrapper">
      <a [attr.aria-label]="
          !product.images?.hasOwnProperty('PRIMARY')
            ? ('productDetails.noProductImage'
              | cxTranslate: { product: product.name })
            : undefined
        " [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" (click)="selectItem(product)"
        [queryParams]="{gaListName: gaListName, entry_source: gaEntrySource}"
        [style.width]="product.servicePart ? '78%' : '100%'"
        >
        <span class="name">{{ product.name }}</span>
      </a>
      <gen-sp-icons *ngIf="product?.servicePart" [product]="product"></gen-sp-icons>
    </div>
    <a *ngIf="product.bundleAvailable"
      [routerLink]="{ cxRoute: 'bundles', params: { productCode: product.code, name: product.slug } } | cxUrl"
      class="buy-in-bundle link cx-action-btn-link">
      Buy In Bundle >
    </a>
    
    <gen-product-badge *ngIf="product?.badges?.length" [badges]="product.badges" [size]="'small'"></gen-product-badge>
  </div>
  <div class="price" *ngIf="product.purchasable || product?.purchaseLabel">
    <gen-info-price-wrapper [product]="product">
      {{ getDisplayPrice(product) }}
    </gen-info-price-wrapper>
  </div>
  <div *ngIf="!product.purchasable && !product?.purchaseLabel" [class.service-parts]="product?.servicePart"
    class="cx-product-price-container non-price">

    <gen-add-to-favorites [product]="product"
      [class.border-grey]="product.erpStatus !== 'DISCONTINUED' && product.purchasable"></gen-add-to-favorites>

    <ng-container *ngIf="!product?.unavailabilityDetail && product?.servicePart">
      <gen-product-purchase-restriction-message [purchaseRestricted]="product?.purchaseRestrictedByScopeRules"
        [messageType]="'tool-tip'">
      </gen-product-purchase-restriction-message>
    </ng-container>

    <div class="position-relative non-price-status"
      [class.align-items-end]="product?.unavailabilityDetail?.type === GenUnavailabilityDetailType.ContactFactoryNotForIndividualSale">
      <ng-container *ngIf="product?.servicePart; else regularProduct;">
        <gen-info-price-wrapper [product]="product">{{ getDisplayPrice(product) }}</gen-info-price-wrapper>

        <div
          *ngIf="product?.unavailabilityDetail?.type === GenUnavailabilityDetailType.ContactFactory 
          || product?.unavailabilityDetail?.type === GenUnavailabilityDetailType.ContactFactoryNotForIndividualSale; else plainText;"
          class="contact-factory-block"
          [class.align-items-end]="product?.unavailabilityDetail?.type === GenUnavailabilityDetailType.ContactFactoryNotForIndividualSale">
          <span *ngIf="product?.unavailabilityDetail?.description" class="unavailability-detail-description">
            {{product?.unavailabilityDetail?.description}}
          </span>
          <a class="call-for-pricing link cx-action-btn-link" (click)="openContactFactory()">
            {{product?.unavailabilityDetail?.label}}
          </a>
        </div>

        <ng-template #plainText>
          <span class="call-for-pricing">{{product?.unavailabilityDetail?.label}}</span>
        </ng-template>
      </ng-container>

      <ng-template #regularProduct>
        <div *ngIf="!product.purchaseLabel" class="position-relative non-price-status-product" (mouseenter)="callForPricingMessage=tooltipMessage"
          (mouseleave)="callForPricingMessage=''">
          <a [href]="contactForPricingHref" class="call-for-pricing link cx-action-btn-link">
            Contact For Pricing
            <gen-info-message [message]="callForPricingMessage" [position]="'position-right'"></gen-info-message>
          </a>
        </div>
      </ng-template>

    </div>
  </div>
  <gen-add-to-cart *ngIf="product.purchasable || product?.purchaseLabel" [product]="product" [purchasable]="true" [productCode]="product.code"
    [showQuantity]="true" [isIcon]="true" [gaListName]="gaListName" [gaEntrySource]="gaEntrySource"></gen-add-to-cart>
  <div class="sp-note-container" *ngIf="isServicePartsEnabled && product?.materialNotes && product?.servicePart">
    <span>
      <strong>Note: </strong>
      <span [innerHTML]="(product?.materialNotes  || '') | safe"></span>
    </span>
  </div>
</div>

<ng-template #plpMbileTmpl>
  <div class="row plp-mobile-item">
    <a [attr.aria-label]="
        !product.images?.hasOwnProperty('PRIMARY')
          ? ('productDetails.noProductImage'
            | cxTranslate: { product: product.name })
          : undefined
      " [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" (click)="selectItem(product)"
      [queryParams]="{gaListName: gaListName, entry_source: gaEntrySource}" class="cx-product-image-container">
      <cx-media class="cx-product-image"
        *ngIf="(product.servicePart && product.images?.PRIMARY) || !product.servicePart; else spGearThumb"
        [container]="product.images?.PRIMARY" format="product" [alt]="product.name || product.summary"></cx-media>
      <ng-template #spGearThumb>
        <img src="../../../../../../assets/icons/sp_gear_thumb.svg" alt="gear" class="sp-gear-thumb">
      </ng-template>
    </a>
    <div class="plp-mobile-product-data">
      <div class="product-name-container">
        <a [attr.aria-label]="
            !product.images?.hasOwnProperty('PRIMARY')
              ? ('productDetails.noProductImage'
                | cxTranslate: { product: product.name })
              : undefined
          "
          [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" (click)="selectItem(product)"
          [queryParams]="{gaListName: gaListName, entry_source: gaEntrySource}">
          <span class="name">{{ product.name }}</span>
        </a>
        <div *ngIf="product.purchasable || product?.purchaseLabel" class="price">
          {{ product.price?.formattedValue }}
          <gen-info-price-wrapper [product]="product"></gen-info-price-wrapper>
        </div>
        <a *ngIf="product.bundleAvailable"
          [routerLink]="{ cxRoute: 'bundles', params: { productCode: product.code, name: product.slug } } | cxUrl"
          class="buy-in-bundle link cx-action-btn-link">
          Buy In Bundle >
        </a>
        <div class="sp-icons-mobile">
          <gen-sp-icons [product]="product"></gen-sp-icons>
        </div>
        
        <gen-product-badge *ngIf="product?.badges?.length" [badges]="product.badges" [size]="'small'"></gen-product-badge>
      </div>
      <div *ngIf="!product.purchasable && !product?.purchaseLabel" class="cx-product-price-container non-price"
        [class.service-parts]="product?.servicePart">
        <gen-add-to-favorites [product]="product"
          [class.border-grey]="product.erpStatus !== 'DISCONTINUED' && product.purchasable"></gen-add-to-favorites>
        <div class="position-relative non-price-status" (mouseenter)="callForPricingMessage=tooltipMessage"
          (mouseleave)="callForPricingMessage=''">
          <ng-container *ngIf="product?.servicePart; else regularProduct;">
            <gen-info-price-wrapper [product]="product" [position]="TooltipPosition.Right">{{ getDisplayPrice(product)
              }}</gen-info-price-wrapper>

            <div
              *ngIf="product?.unavailabilityDetail?.type === GenUnavailabilityDetailType.ContactFactory 
              || product?.unavailabilityDetail?.type === GenUnavailabilityDetailType.ContactFactoryNotForIndividualSale; else plainText;"
              class="contact-factory-block">
              <span *ngIf="product?.unavailabilityDetail?.description" class="unavailability-detail-description">
                {{product?.unavailabilityDetail?.description}}
              </span>
              <a class="call-for-pricing link cx-action-btn-link" (click)="openContactFactory()">
                {{product?.unavailabilityDetail?.label}}
              </a>
            </div>

            <gen-product-purchase-restriction-message *ngIf="!product?.unavailabilityDetail"
              [purchaseRestricted]="product?.purchaseRestrictedByScopeRules" [messageType]="'tool-tip'"
              [tooltipPosition]="'position-left'">
            </gen-product-purchase-restriction-message>

            <ng-template #plainText>
              <span class="call-for-pricing"
                *ngIf="product?.unavailabilityDetail">{{product?.unavailabilityDetail?.label}}</span>
            </ng-template>
          </ng-container>

          <ng-template #regularProduct>
            <div *ngIf="!product.purchaseLabel" class="position-relative" (mouseenter)="callForPricingMessage=tooltipMessage"
              (mouseleave)="callForPricingMessage=''">
              <a [href]="contactForPricingHref" class="call-for-pricing link cx-action-btn-link">
                Contact For Pricing
                <gen-info-message [message]="callForPricingMessage" [position]="'position-right'"></gen-info-message>
              </a>
            </div>
          </ng-template>

        </div>
      </div>
      <gen-add-to-cart *ngIf="product.purchasable || product?.purchaseLabel" [product]="product" [purchasable]="true" [productCode]="product.code"
        [showQuantity]="true" [isMobileBtn]="true" [gaListName]="gaListName" [gaEntrySource]="gaEntrySource" [isIcon]="true"></gen-add-to-cart>
    </div>
  </div>
</ng-template>